import {
  store
} from './../store';
let apiUrl = '';
// 根据 process.env.HOST 的值判断当前是什么环境
// 命令：npm run build -- test ，process.env.HOST就设置为：'test'
let HOST = process.env.HOST;
switch(HOST){
case 'dev':
// apiUrl="http://api.milijiazhang.com";
// apiUrl = "http://localhost:8600"
apiUrl = 'http://192.168.31.26:8600';
// apiUrl="http://143.64.18.146:7080";
break;
case 'test':
apiUrl="http://40.72.117.12:7001";
break;
case 'prod':
// apiUrl="http://api.milijiazhang.com";
apiUrl="https://api.milijiazhang.com";
// apiUrl="http://40.162.192.186:9000";
// apiUrl="http://localhost:8165";
break;
case 'localhost':
// apiUrl="http://127.0.0.1:8100";// 后端测试使用
break;
default:
apiUrl="http://api.milijiazhang.com";
}
// 全局应用配置类
let AppConfig = {
  baseUrl: apiUrl,
  googleDownload: 'http://139.224.165.13:50005/content/res/google.exe',
  MicroSite: 'http://139.224.165.13:60002/index.html?v=0.6',
  currentVersion: '0.6', // 地址版本和【v】需要和后台WebConfig配置UiVersion保持一致
  qrCodeView: '?imageView2/1/w/300',
  imgView150: '?imageView2/2/w/150/',
  imgView80: '?imageView2/1/w/80/h/80',
  tableSmallImgView: '?imageView2/1/w/50/h/50',
  water400: '-w400water',
  water600: '-w600water',
  water700: '-w700water',
  water800: '-w800water',
  // unifiedNoneAuth: false, //统一处理401，页面加载完成并且校验权限后，自动设置为true
  ajaxCode: {
    success: 200,
    error: 10001
  },
  fileLimits: {// 不同类型文件 大小 单位 M 0 图片 1 视频 2 word 3 excel 4 ppt 5 pdf
    0: {
      name: '图片',
      size: 10
    },
    1: {
      name: '视频',
      size: 100
    },
    2: {
      name: 'Word',
      size: 1024
    },
    3: {
      name: 'Excel',
      size: 1024
    },
    4: {
      name: 'PPT',
      size: 1024
    },
    5: {
      name: 'PDF',
      size: 1024
    }
  }
};

// 全局工具类
let AppUtil = {
  StorageUtilManager: new Object({
    createStorageUtil: function () {
      if (window.applicationCache) {
        return AppUtil.LocalStorageUtil;
      } else {
        return AppUtil.CookieStorageUtil;
      }
    }
  }),
  /**
   * implement Storage
   * write()
   * get()
   */
  CookieStorageUtil: {
    write: function (key, dataObj) {
      this._clearCookie(key);
      // 写入的字符串
      var dataObjStr = JSON.stringify(dataObj);
      this._setCookie(key, dataObjStr, 15);
    },
    get: function (key) {
      return this._getCookie(key);
    },
    clean: function (key) {
      this._clearCookie(key);
    },
    _setCookie: function (cname, cvalue, exdays) {
      var d = new Date();
      d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
      var expires = 'expires=' + d.toUTCString();
      var path = 'path=/';
      document.cookie = cname + '=' + cvalue + '; ' + expires + '; ' + path;
    },
    _getCookie: function (cname) {
      var name = cname + '=';
      var ca = document.cookie.split(';');
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') c = c.substring(1);
        if (c.indexOf(name) != -1) return c.substring(name.length, c.length);
      }
      return null;
    },
    _clearCookie: function (key) {
      this._setCookie(key, '', -1);
    }
  },
  /**
   * implement Storage
   * write()
   * get()
   */
  LocalStorageUtil: {
    write: function (key, dataObj) {
      this._writeLocalStorage(key, dataObj);
    },
    get: function (key) {
      return this._getFromLocalStorage(key);
    },
    clean: function (key) {
      this._removeLocalStorage(key);
    },
    _writeLocalStorage: function (key, dataObj) {
      var localStorage = window.localStorage;
      localStorage.removeItem(key);
      // 对象转化为字符串,将objStr按正常的方式存入localStorage中
      var dataObjStr = '';
      if (typeof (dataObj) !== 'string') {
        dataObjStr = JSON.stringify(dataObj);
      } else {
        dataObjStr = dataObj;
      }
      localStorage.setItem(key, dataObjStr);
    },
    _getFromLocalStorage: function (key) {
      var localStorage = window.localStorage;
      return localStorage.getItem(key);
    },
    _removeLocalStorage: function (key) {
      var localStorage = window.localStorage;
      localStorage.removeItem(key);
    }
  },
  // token
  TokenUtil: new Object({
    tokenDataKey: 'MiniProgramTokenData',
    saveTokenData: function (tokenData) {
      AppUtil.StorageUtilManager.createStorageUtil().write(
        this.tokenDataKey,
        tokenData
      );
    },
    getTokenData: function () {
      return AppUtil.StorageUtilManager.createStorageUtil().get(
        this.tokenDataKey
      );
    },
    clearTokenData: function () {
      AppUtil.StorageUtilManager.createStorageUtil().clean(
        this.tokenDataKey
      );
    }
  })

};

var AppHelper = {

  getTimeWords: function () { // 时间说辞
    var now = new Date(),
      hour = now.getHours();
    if (hour < 6) {
      return ('凌晨好')
    } else if (hour < 9) {
      return ('早上好')
    } else if (hour < 12) {
      return ('上午好')
    } else if (hour < 14) {
      return ('中午好')
    } else if (hour < 17) {
      return ('下午好')
    } else if (hour < 19) {
      return ('傍晚好')
    } else if (hour < 22) {
      return ('晚上好')
    } else {
      return ('夜里好')
    }
  }
};

let app = {
  config: AppConfig,
  tokenUtil: AppUtil.TokenUtil,
  cookieUtil: AppUtil.CookieStorageUtil,
  storageUtil: AppUtil.LocalStorageUtil,
  helper: AppHelper
};

let vueDataUtil = {
  checkHasPrivilege (elementId) { // true or false
    var privilegeList = store.state.userPrivilegeList;
    return privilegeList.findIndex(p => p.ElementId == elementId) > -1;
  }
};

export {
  app,
  vueDataUtil
};



// WEBPACK FOOTER //
// ./src/base/config.js